export const Panel = 'Panel'
export const SideBar = 'SideBar'
